module.exports = __webpack_public_path__ + "img/rev-header-default.0f307b9d.jpg";